import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthorizationService } from './authorization.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  IdToken = localStorage.getItem("IdToken");
  
  constructor(private injector: Injector) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>  {
    // console.log(this.IdToken );
    const authService = this.injector.get(AuthorizationService);
    const tokenReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + this.IdToken,
        'x-api-key': 'xND898izLz9qo3sj27WPP5LAbpbkMOff9dgbsbwO'
      }
    });
    return next.handle(tokenReq);
  }
}
